<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 ref="topDashboardPaslaugos" class="mb-4">Aktyvios paslaugos</h3>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="filterItemList"
      :search="search"
      :page.sync="page"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat
          ><v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template #[`item.busena`]="{ item }">
        <el-hipoteka-busena
          :busena="item.busena"
          :tooltip="item.busenaTooltip"
        />
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          :item="item"
          @editItem="editItem(item)"
          @viewItem="editItem(item)"
          @deleteItem="deleteItem(item)"
          @restoreItem="restoreItem(item)"
          @priskirtiItem="startPriskyrimas(item)"
          @cancelPriskirtiItem="cancelPriskyrimas(item)"
        />
        <v-tooltip top v-if="item.obj_vykdo_snau_id">
          <template v-slot:activator="{ on, attrs }">
            <v-chip small outlined class="mt-1 mb-1" v-bind="attrs" v-on="on">
              <div class="tikrina-chip text-truncate">
                Priskirta {{ item.obj_vykdo }}
              </div>
            </v-chip>
          </template>
          <div class="tooltip-text">
            Priskirta<br />
            {{ item.obj_vykdo }}
          </div>
        </v-tooltip>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-delete
      title="Šalinti dokumentą?"
      :text="
        `Ar norite pašalinti perduotą dokumentą <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
    <modal-confirm
      title="Dokumento priskyrimas"
      :text="confirmText"
      :item="confirmItem"
      action="Priskyrimas"
      v-model="showConfirm"
      @confirmPriskyrimas="confirmPriskyrimas"
      @cancelConfirm="cancelConfirm"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../../mixins/userRole'
import HipotekaMap from './../hipotekaMap'
import NtrPaslaugosMap from './../../ntrpaslaugos/NtrPaslaugosMap'
import ModalDelete from '../../modals/ModalDelete'
import ModalConfirm from '../../modals/ModalConfirm'

export default {
  name: 'DashboardPaslaugos',
  components: {
    ModalDelete,
    ModalConfirm,
  },
  mixins: [userRole],
  data() {
    return {
      pageloading: true,
      loading: true,
      pranesimai: [],
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      headers: [
        {
          text: 'Dokumento numeris',
          align: 'start',
          value: 'dokumento_numeris',
        },
        {
          text: 'Perdavimo data',
          align: 'start',
          value: 'obj_perdavimo_data',
        },
        {
          text: 'Šalis (pirma)',
          align: 'start',
          value: 'skolininkai',
        },
        {
          text: 'Šalis (antra)',
          align: 'start',
          value: 'kreditoriai',
        },
        {
          text: 'Pranešimo rūšis',
          align: 'start',
          value: 'hipotekaTipas',
        },
        {
          text: 'Būsena',
          align: 'start',
          value: 'busena',
        },
        {
          text: 'Būsenos data',
          align: 'start',
          value: 'busenos_data',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
      itemsPerPageOptions: [5, 10, 50, -1],
      pageSize: 5,
      page: 1,
      lockInterval: null,
      lockTimeout: 10000,
      confirmText: null,
      confirmItem: null,
      showConfirm: false,
    }
  },
  computed: {
    ...mapGetters([
      'userID',
      'objektasID',
      'hipotekaTipas',
      'prasymasID',
      'prasymasTipas',
      'listInfo',
    ]),

    asmuoRole() {
      return HipotekaMap['asmenysRoles'].informuojamas
    },
    filterItemList() {
      return this.pranesimai.map(item => {
        if (item.obj_id) {
          item.hipotekaTipas = HipotekaMap['hipotekaTipas'][
            item.pranesimo_rusis
          ]
            ? HipotekaMap['hipotekaTipas'][item.pranesimo_rusis].title
            : item.pranesimo_rusis
        } else {
          item.hipotekaTipas = NtrPaslaugosMap.getPrasymasTipas(
            item.pranesimo_rusis
          ).title
        }
        item.skolininkai = item.skol_ir_gav.join(', ')
        item.kreditoriai = item.kred_ir_dav.join(', ')

        if (item.obj_uzrakinta) {
          item.canLock = true
          item.lockMsg = item.obj_uzrakines_asmuo
        } else {
          item.canEdit =
            item.busena === 'rengiamas' ||
            item.busena === 'grazintas' ||
            (item.busena === 'perduotas' && this.roleRG) ||
            (item.busena === 'laukia_patvirtinimo' && this.roleOr(['DT_JA']))
          item.canView = !item.canEdit
          item.canDelete = item.busena == 'rengiamas'
        }
        if (item.zug_pasirasymas_vadovas) {
          if (
            (this.roleDT && item.zug_busena_tolimesne === 'perduotas') ||
            (this.roleRGV && item.zug_busena_tolimesne === 'atmestas')
          ) {
            item.showSign = true
          }

          if (
            ((item.busena === 'rengiamas' &&
              !this.roleOr(['DT_notaras', 'DT_notaro_atstovas'])) ||
              (item.busena === 'perduotas' &&
                !this.roleOr(['RG_NTR_vadovas']))) &&
            !item.obj_uzrakinta
          ) {
            item.canView = true
            item.canEdit = false
            item.canDelete = false
          }
        }

        item.canPriskirti = false
        item.canCancelPriskirti = false
        if (this.isJuridinis && item.busena === 'laukia_patvirtinimo') {
          const priskirtaSau = item.obj_vykdo_snau_id === this.userID
          item.canPriskirti = !priskirtaSau
          item.canCancelPriskirti = priskirtaSau
        }

        item.busenaTooltip = null
        if (item.busena === 'laukia_apmokejimo') {
          item.busenaTooltip = 'Apmoka savitarnoje dokumentą inicijavęs asmuo'
        }

        return item
      })
    },
    hideFooter() {
      return this.filterItemList.length <= 5
    },
    isLocked() {
      return this.pranesimai.filter(item => item.obj_uzrakinta).length > 0
    },
    isJuridinis() {
      return this.roleOr(['DT_JA'])
    },
  },
  beforeDestroy() {
    this.stopLoading()
  },
  created() {
    this.loading = true
    this.getData()
  },
  methods: {
    getData() {
      this.$axios
        .get(`pagrindinis/aktyvios-paslaugos`)
        .then(res => {
          this.pranesimai = res.data.pranesimai
          this.checkLoading()
          if (this.$route.params.toList) {
            this.search = this.listInfo.search
            this.pageSize = this.listInfo.pageSize
            this.page = this.listInfo.page
            this.$route.params.toList = false
            this.$vuetify.goTo(this.$refs.topDashboardPaslaugos)
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    checkLoading() {
      if (this.isLocked) {
        if (!this.lockInterval) {
          this.lockInterval = setInterval(() => {
            this.getData()
          }, this.lockTimeout)
        }
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      clearInterval(this.lockInterval)
    },
    editItem(item) {
      const listInfo = {
        obj_id: item.obj_id,
        pra_id: item.pra_id,
        search: this.search,
        page: this.page,
        pageSize: this.pageSize,
        routeName: 'pagrindinis',
      }
      this.$store.dispatch('listInfo', listInfo).then(() => {
        if (item.pra_id) {
          this.editPrasymas(item)
          return
        }
        this.editObjektas(item)
      })
    },
    editObjektas(item) {
      const objektasID = item.obj_id
      this.$store.dispatch('objektasID', objektasID)
      this.$store.dispatch('hipotekaTipas', item.pranesimo_rusis)
      let routeName = 'hipotekaPranesimas'
      if (
        this.roleRG ||
        (item.busena === 'laukia_patvirtinimo' && this.roleOr(['DT_JA']))
      ) {
        routeName = 'hipotekaRegistravimas'
      }

      this.$router.push({
        name: routeName,
        params: {
          objektasID: objektasID,
        },
      })
    },
    editPrasymas(item) {
      const prasymasID = item.pra_id
      this.$store.dispatch('prasymasID', prasymasID)
      this.$store.dispatch('prasymasTipas', item.pranesimo_rusis)

      this.$router.push({
        name: this.roleRG ? 'regPrasymasRegistravimas' : 'regPrasymasDuomenys',
        params: {
          prasymasID: prasymasID,
        },
      })
    },
    deleteItem(item) {
      this.modalDeleteVardas =
        item.dokumento_numeris ?? item.obj_id ?? item.pra_id
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.loading = true

      let url = `objektas/${item.obj_id}`
      if (item.pra_id) {
        url = `ntrpaslaugos/prasymas/${item.pra_id}`
      }

      this.$axios
        .delete(url)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    startPriskyrimas(item) {
      this.priskirtiItem(item, true)
    },
    cancelPriskyrimas(item) {
      this.priskirtiItem(item, false)
    },
    priskirtiItem(item, priskirti, force = false) {
      const data = {
        obj_id: item.obj_id,
        priskirti: priskirti,
        force: force,
      }

      this.$axios
        .post(`objektas/${item.obj_id}/priskirti`, data)
        .then(res => {
          const priskyrimas = res.data.priskyrimas

          if (priskyrimas.success) {
            window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')
            this.getData()
            return
          }

          item.obj_vykdo = priskyrimas.obj_vykdo
          item.obj_vykdo_snau_id = priskyrimas.obj_vykdo_snau_id
          this.openConfirmPriskyrimas(item)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          //
        })
    },
    openConfirmPriskyrimas(item) {
      this.confirmText = `Dokumentas jau yra priskirtas <b>${item.obj_vykdo}</b>. <br />Ar tikrai norite dokumentą priskirti sau?`
      this.confirmItem = item
      this.showConfirm = true
    },
    confirmPriskyrimas(item) {
      this.priskirtiItem(item, true, true)
    },
    cancelConfirm() {
      this.showConfirm = false
    },
  },
}
</script>
<style lang="scss" scoped>
.tikrina-chip {
  max-width: 110px;
}
</style>
